import { render, staticRenderFns } from "./personEdit.vue?vue&type=template&id=7128a847&scoped=true&"
import script from "./personEdit.vue?vue&type=script&lang=js&"
export * from "./personEdit.vue?vue&type=script&lang=js&"
import style0 from "./personEdit.vue?vue&type=style&index=0&id=7128a847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128a847",
  null
  
)

export default component.exports